import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=172c5506&scoped=true"
import script from "./BlogCard.vue?vue&type=script&lang=js"
export * from "./BlogCard.vue?vue&type=script&lang=js"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=172c5506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c5506",
  null
  
)

export default component.exports